/*
 * サブシステム名：マスタ管理
 * 機能名：テンプレートマスタ登録
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdNumericBox from '@/components/DdNumericBox'
import DdQuillEditor from '@/components/DdQuillEditor'
import DdTextArea from '@/components/DdTextArea'

import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import validators from '@/rahmen/validators'
import message from '@/ddv2.library/messages'

export default {
  name: 'MstMailTemplateEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},
    showCopyDialog: false,
    modeOfEdit: 2,
    modeKengen: 2
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdDateBox,
    DdDefaultButton,
    DdFooterButton,
    DdNumericBox,
    DdQuillEditor,
    DdTextArea
  },
  computed: {
    ...mapGetters({
    }),
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    console.log('mounted')
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        console.log(self.id)
        self.HttpClient
          .get(`/api/v1/MstMailTemplate/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload

            delete self.rec.tekiyoStartYmd
            delete self.rec.tekiyoEndYmd

            resolve()
          })
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: [],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.rec = {
              templateNm: '',
              specificProgramId: '',
              specificFunctionId: '',
              templateTitle: '',
              templateText: '',
              tekiyoStartYmdString: '2000/01/01',
              tekiyoEndYmdString: '2100/01/01',
              hyojiOrder: '9999'
            }
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            resolve()
          })
        },
        existsIdMethod: function () {
          console.log('existsIdMethod', self.id)
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstMailTemplate/delete?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.modeOfEdit = 0
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            self.fetchData()
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.templateNm !== self.rec.templateNm
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            // self.transition(1, { id: id }, self.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.id === 0) {
        f = this.HttpClient.post('/api/v1/MstMailTemplate/create', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/MstMailTemplate/update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    },
    deleteValidate: function () {
      if (this.cloneData.templateNm !== this.rec.templateNm) {
        this.$refs.templateNm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['テンプレート名称']))
        this.setInvalidSummaryMessage('COME0015')
        return false
      }
      return true
    }
  }
}
